export default {
    pageName: 'อนุมัติคำร้อง',
    search: {
        title: '',
        placeholder: 'ค้นหาสำนักงาน'
    },
    header: {
        full: 'สำนักงาน',
        sub: 'ชื่อย่อ'
    }
}
